import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';

function AppLayout() {
  return (
    <Layout className="min-h-screen">
      <Layout.Content className="flex flex-col">
        <Outlet />
      </Layout.Content>
    </Layout>
  );
}

export default AppLayout;
